import axios from "axios";
import querystring from "querystring";
require("@babel/polyfill");
import QS from "qs";
//引入nprogress
import NProgress from "nprogress";
import Cookies from "js-cookie";
import storage from "good-storage";
import { getSessionId } from "./session";
// axios 配置
axios.defaults.timeout = 30000; //请求超时，适当修改

axios.defaults.headers["Content-Type"] =
  "application/x-www-form-urlencoded;utf-8";
axios.defaults.headers["ASP.NET_SessionId"] = getSessionId();

//  axios.defaults.baseURL = "https://192.168.200.196:5001/";"周
if (process.env.NODE_ENV == "development") {
  //axios.defaults.baseURL = "https://pcapi.51callme.com";
  axios.defaults.baseURL = "http://192.168.200.81:58103";
} else if (process.env.NODE_ENV == "production") {
  axios.defaults.baseURL = "https://pcapi.51callme.com";
}
// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    const token = Cookies.get("registerCode");
    config.params = {
      _AppID: 103 //PC
    };
    if (token) {
      config.params._RegisterCode = token
    }
    // 或者 config.headers.authorization = storage.get("token") || "";
    NProgress.start();
    return config;
  },
  (error) => {
    console.error(error);
    return Promise.reject(error);
  }
);

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
 */
const errorHandle = (status, other) => {
  // 状态码判断
  switch (status) {
    // 401
    case 401:
      console.log("403");
      break;
    // 403
    case 403:
      console.log("403");
      storage.clear();
      setTimeout(() => {}, 1000);
      break;
    // 404请求不存在
    case 404:
      console.log("请求的资源不存在");
      break;
    default:
      console.log(other);
  }
};

// http response 拦截器
axios.interceptors.response.use(
  (response) => {
    NProgress.done();
    if (response.data.ReturnStatus) {
      return response;
    } else {
      switch (response.data.MessageID) {
        case -10010:
        case -10016:
        case -10087:
        case -10289:
        case -10442:
          // -10010	登录失效
          // -10016	当前状态为未登录
          // -10087	登录失效, 请重新登录
          // -10289	该用户未登录或无效
          // -10442 您被挤下线了
          layui.use(["layer"], function () {
            var $ = layui.jquery,
              layer = layui.layer;
            layer.msg(response.data.MessageCN, { icon: 2 });
            storage.clear();
            Cookies.remove("userName");
            Cookies.remove("registerCode");
            Cookies.remove("userInfo");
            let loginStr =
              '<div class="btn-group"><span id="login" onclick="openLoginCon()">登录</span><span id="register" onclick="openRegisterCon()">注册</span > </div>';
            $("#headerInfo").html(loginStr);
            window.location.href = "./index.html";
          });
          break;
        default:
          if (response.data.MessageCN) {
            layui.use(["layer"], function () {
              var $ = layui.jquery,
                layer = layui.layer;
              layer.msg(response.data.MessageCN, { icon: 2 });
            });
          }
          break;
      }
      return response;
    }
  },
  (error) => {
    NProgress.done();
    const { response } = error;
    if (response) {
      // 请求已发出，但是不在2xx的范围
      errorHandle(response.status, response.data.message);
      return Promise.reject(response);
    } else {
      // 断网的情况
      console.error("网络连接已断开");
    }
  }
);

/**
 * 封装axios的通用请求
 * @param  {string}   url       请求的接口URL
 * @param  {object}   data      传的参数，没有则传空对象
 * @param  {Function} fn        回调函数 fn(返回的数据,错误信息)
 * @return
 */
export function post(url, data) {
  NProgress.start();
  return axios
    .post(url, QS.stringify(data))
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.error(err);
    });
}

export function rawPost(url, data) {
  NProgress.start();
  return axios
    .post(url, data)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.error(err);
    });
}

export function get(url, params) {
  NProgress.start();

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.data);
      });
  });
}

export function getBLOB(url) {
  NProgress.start();

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        responseType: "arraybuffer",
      })
      .then((res) => {
        resolve(res);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function formPost(url, data) {
  NProgress.start();
  let config = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return axios
    .post(url, data, config)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      return Promise.error(err);
    });
}
